export const administration = {
  // Вкладка «Пользователи»
  users: {
    viewList: '[perm]-[administration]-view-user-list',
    tableFiltering: '[perm]-[administration]-user-table-filtering',
    view: '[perm]-[administration]-view-user',
    registration: '[perm]-[administration]-user-registration',
    edit: '[perm]-[administration]-edit-user',
    block: '[perm]-[administration]-block-user',
    unblock: '[perm]-[administration]-unblock-user',
  },

  // Вкладка «Роли»
  roles: {
    viewList: '[perm]-[administration]-view-role-list',
    view: '[perm]-[administration]-view-role',
    add: '[perm]-[administration]-add-user-role',
    edit: '[perm]-[administration]-edit-user-role',
    delete: '[perm]-[administration]-delete-user-role',
  },

  // Вкладка «Организации»
  orgs: {
    viewList: '[perm]-[administration]-view-organization-list',
    view: '[perm]-[administration]-view-organization',
    add: '[perm]-[administration]-add-organization',
    edit: '[perm]-[administration]-edit-organization',
    addDepartment: '[perm]-[administration]-add-department',
    addFacility: '[perm]-[administration]-add-facility',
    editDepartment: '[perm]-[administration]-edit-department',
    editFacility: '[perm]-[administration]-edit-facility',
    deleteDepartment: '[perm]-[administration]-delete-department',
    deleteFacility: '[perm]-[administration]-delete-facility',
    block: '[perm]-[administration]-block-organization',
    unblock: '[perm]-[administration]-unblock-organization',
  },

  // Вкладка «Группы животных»
  animalGroups: {
    viewList: '[perm]-[administration]-view-animal-groups',
    edit: '[perm]-[administration]-edit-animal-groups',
  },
} as const;
